import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import apiServices from "../../../services/api.services";
function generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
}

export const fetchShops = createAsyncThunk('shops/fetchShops', async () => {
    const response = await apiServices.shopList();
    return response.data;
})
const variation_demo = {
    name: "Name",
    id: "id1",
    options: [
        {
            name: "Option1",
            image: ""
        },
        {
            name: "Option2",
            image: ""
        },
    ]
}

export const variationsSlice = createSlice({
    name: 'variations',
    initialState: {
        isLoading: false,
        error: null,
        variations: [
            {
                name: "",
                id: generateRandomString(10),
                options: [
                    {
                        name: "",
                        image: ""
                    }
                ]
            }
        ],
        addImage: true,
    },
    reducers: {
        addNewVariation: (state, action) => {
            state.variations = [...state.variations, {
                name: "",
                id: "",
                options: [
                    {
                        name: "",
                        image: ""
                    }
                ]
            }]
        },
        editVariation: (state, action) => {
            const { id, name, options } = action.payload;
            const variationIndex = state.variations.findIndex((variation) => variation.id === id);
            if (variationIndex !== -1) {
                state.variations[variationIndex] = {
                    ...state.variations[variationIndex],
                    name: name || state.variations[variationIndex].name,
                    options: options || state.variations[variationIndex].options,
                };
            }
        },
        changeAddImage: (state, action) => {
            state.addImage = action.payload;
        },
        deleteVariation: (state, action) => {
            const { id } = action.payload;
            state.variations = state.variations.filter(variation => variation.id !== id);
        }
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(fetchShops.pending, (state) => {
    //             state.isLoading = true
    //         })
    //         .addCase(fetchShops.fulfilled, (state, action) => {
    //             state.isLoading = false
    //             state.shops = action.payload
    //             state.error = null
    //         })
    //         .addCase(fetchShops.rejected, (state, action) => {
    //             state.isLoading = false
    //             state.error = action.error.message
    //         })
    // },
})

export const {addNewVariation, editVariation, changeAddImage, deleteVariation} = variationsSlice.actions

export default variationsSlice.reducer